module.exports = __webpack_public_path__ + "media/images/athletes/531-ff86a1bc2908452e7fc7add228613a46.png";